import { RawTemplate, TemplateEntity } from '@entities/Template/Types';
import { QuestionTypeEnum } from '@shared/Enums/QuestionTypeEnum';
import { RawMedia } from '@entities/Media/Types';

export const LandingDIYTemplatesData: RawTemplate[] = [
    {
        id: 117,
        data: {
            fragments: [
                {
                    id: 86,
                    qty: null,
                    data: {
                        '0': {
                            key: 'L',
                            value: 10,
                            select: QuestionTypeEnum.INPUT,
                            answers: [
                                {
                                    title: '10',
                                    value: 10,
                                    selected: true,
                                },
                            ],
                            question: 'Length of area to be paved (m)',
                        },
                        '1': {
                            key: 'W',
                            value: 10,
                            select: QuestionTypeEnum.INPUT,
                            answers: [
                                {
                                    title: '10',
                                    value: 10,
                                    selected: true,
                                },
                            ],
                            question: 'Width of area to be paved (m)',
                        },
                        fragments: [],
                        item_types: [],
                        var_mapping: null,
                    },
                    slug: 'Tiling a wall',
                    title: 'Tiling a wall',
                    frozen: false,
                    publish: true,
                    created_at: '2024-11-13T18:28:00.000000Z',
                    deleted_at: null,
                    updated_at: '2025-02-27T09:04:20.000000Z',
                },
            ],
            summary_item_types_template: [],
        },
        galleries: [
            {
                created_at: '2024-12-10T17:09:11.000000Z',
                deleted_at: null,
                galleryable_id: 1,
                galleryable_type: 'App\\Models\\Template',
                id: 1,
                medias: [
                    {
                        created_at: '2024-12-10T17:09:11.000000Z',
                        deleted_at: '2024-12-10T17:09:11.000000Z',
                        filename:
                            'qJYUfKjLcDY0fN1SHj8jYAJniix1m5a0jDz8S78c.jpg',
                        gallery_id: 1,
                        id: 1,
                        mime_type: 'image/jpeg',
                        size: 1,
                        updated_at: '2024-12-10T17:09:11.000000Z',
                        url: 'http://preprod-cashbuildapi.gobuild.co.za/images/8VcfYF53fT4zCthcU6UgvhJ7xVUSOoJuFvi2OsVB.jpg',
                    },
                ],
                updated_at: '2024-12-10T17:09:11.000000Z',
            },
        ],
        paid: false,
        slug: 'Tiling a wall',
        title: 'Tiling a wall',
        bought: false,
        frozen: false,
        counted: true,
        publish: true,
        reviews: 202,
        categories: [
            {
                id: 1,
                slug: null,
                category: 'DIY',
                created_at: '2024-05-27T15:02:05.000000Z',
                deleted_at: null,
                updated_at: '2024-11-20T08:23:54.000000Z',
                description: '',
            },
        ],
        created_at: '2024-12-10T17:09:10.000000Z',
        deleted_at: null,
        updated_at: '2025-05-15T10:04:59.000000Z',
        description: 'templates/a6dece74e38ba86b160c13f43dcf9632.html',
        short_description:
            'Pave any external area with the pavers of your choice, including all the accessories and tools you require.',
        template_group_id: null,
    },

    {
        id: 116,
        data: {
            fragments: [
                {
                    id: 86,
                    qty: null,
                    data: {
                        '0': {
                            key: 'L',
                            value: 10,
                            select: QuestionTypeEnum.INPUT,
                            answers: [
                                {
                                    title: '10',
                                    value: 10,
                                    selected: true,
                                },
                            ],
                            question: 'Length of area to be paved (m)',
                        },
                        '1': {
                            key: 'W',
                            value: 10,
                            select: QuestionTypeEnum.INPUT,
                            answers: [
                                {
                                    title: '10',
                                    value: 10,
                                    selected: true,
                                },
                            ],
                            question: 'Width of area to be paved (m)',
                        },
                        fragments: [],
                        item_types: [],
                        var_mapping: null,
                    },
                    slug: null,
                    title: 'Paving',
                    frozen: false,
                    publish: true,
                    created_at: '2024-11-13T18:28:00.000000Z',
                    deleted_at: null,
                    updated_at: '2025-02-27T09:04:20.000000Z',
                },
            ],
            summary_item_types_template: [],
        },
        galleries: [
            {
                created_at: '2024-12-10T17:09:11.000000Z',
                deleted_at: null,
                galleryable_id: 1,
                galleryable_type: 'App\\Models\\Template',
                id: 1,
                medias: [
                    {
                        created_at: '2024-12-10T17:09:11.000000Z',
                        deleted_at: '2024-12-10T17:09:11.000000Z',
                        filename:
                            'qJYUfKjLcDY0fN1SHj8jYAJniix1m5a0jDz8S78c.jpg',
                        gallery_id: 1,
                        id: 1,
                        mime_type: 'image/jpeg',
                        size: 1,
                        updated_at: '2024-12-10T17:09:11.000000Z',
                        url: 'http://preprod-cashbuildapi.gobuild.co.za/images/qJYUfKjLcDY0fN1SHj8jYAJniix1m5a0jDz8S78c.jpg',
                    },
                ],
                updated_at: '2024-12-10T17:09:11.000000Z',
            },
        ],
        paid: false,
        slug: 'Paving',
        title: 'Paving',
        bought: false,
        frozen: false,
        counted: true,
        publish: true,
        reviews: 202,
        categories: [
            {
                id: 1,
                slug: null,
                category: 'DIY',
                created_at: '2024-05-27T15:02:05.000000Z',
                deleted_at: null,
                updated_at: '2024-11-20T08:23:54.000000Z',
                description: '',
            },
        ],
        created_at: '2024-12-10T17:09:10.000000Z',
        deleted_at: null,
        updated_at: '2025-05-15T10:04:59.000000Z',
        description: 'templates/a6dece74e38ba86b160c13f43dcf9632.html',
        short_description:
            'Pave any external area with the pavers of your choice, including all the accessories and tools you require.',
        template_group_id: null,
    },

    {
        id: 134,
        data: {
            fragments: [
                {
                    id: 86,
                    qty: null,
                    data: {
                        '0': {
                            key: 'L',
                            value: 10,
                            select: QuestionTypeEnum.INPUT,
                            answers: [
                                {
                                    title: '10',
                                    value: 10,
                                    selected: true,
                                },
                            ],
                            question: 'Length of area to be paved (m)',
                        },
                        '1': {
                            key: 'W',
                            value: 10,
                            select: QuestionTypeEnum.INPUT,
                            answers: [
                                {
                                    title: '10',
                                    value: 10,
                                    selected: true,
                                },
                            ],
                            question: 'Width of area to be paved (m)',
                        },
                        fragments: [],
                        item_types: [],
                        var_mapping: null,
                    },
                    slug: null,
                    title: 'Paving',
                    frozen: false,
                    publish: true,
                    created_at: '2024-11-13T18:28:00.000000Z',
                    deleted_at: null,
                    updated_at: '2025-02-27T09:04:20.000000Z',
                },
            ],
            summary_item_types_template: [],
        },
        galleries: [
            {
                created_at: '2024-12-10T17:09:11.000000Z',
                deleted_at: null,
                galleryable_id: 1,
                galleryable_type: 'App\\Models\\Template',
                id: 1,
                medias: [
                    {
                        created_at: '2024-12-10T17:09:11.000000Z',
                        deleted_at: '2024-12-10T17:09:11.000000Z',
                        filename:
                            'qJYUfKjLcDY0fN1SHj8jYAJniix1m5a0jDz8S78c.jpg',
                        gallery_id: 1,
                        id: 1,
                        mime_type: 'image/jpeg',
                        size: 10132603,
                        updated_at: '2024-12-10T17:09:11.000000Z',
                        url: 'http://preprod-cashbuildapi.gobuild.co.za/images/zFlDjJdew3JafZVsNZiT6GDZwdwd7h5xxPTfWtor.jpg',
                    },
                ],
                updated_at: '2024-12-10T17:09:11.000000Z',
            },
        ],
        paid: false,
        slug: 'Tiling a Floor',
        title: 'Tiling a Floor',
        bought: false,
        frozen: false,
        counted: true,
        publish: true,
        reviews: 202,
        categories: [
            {
                id: 1,
                slug: null,
                category: 'DIY',
                created_at: '2024-05-27T15:02:05.000000Z',
                deleted_at: null,
                updated_at: '2024-11-20T08:23:54.000000Z',
                description: '',
            },
        ],
        created_at: '2024-12-10T17:09:10.000000Z',
        deleted_at: null,
        updated_at: '2025-05-15T10:04:59.000000Z',
        description: 'templates/a6dece74e38ba86b160c13f43dcf9632.html',
        short_description:
            'Pave any external area with the pavers of your choice, including all the accessories and tools you require.',
        template_group_id: null,
    },
];
